export { default } from './BlockNoticeCard';
